import { render, staticRenderFns } from "./OrganizationShifts.vue?vue&type=template&id=2e17bec2&scoped=true&"
import script from "./OrganizationShifts.vue?vue&type=script&lang=js&"
export * from "./OrganizationShifts.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationShifts.vue?vue&type=style&index=0&id=2e17bec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e17bec2",
  null
  
)

export default component.exports